import { type ProjectCode } from '@constants'
import { useCallbackEvent } from '@dni-react-hooks/use-callback-event'
import { useApiCampaignActivityInfo } from '@hooks-api/fortune/useApiCampaignActivityInfo'
import { useApiCampaignProductsList } from '@hooks-api/fortune-fastpass/use-api-campaign-products-list'
import { useCallback, useMemo } from 'react'
import { useFpCampaignProductsStore } from './useFpCampaignProductsStore'

export const useFpCampaignProductsService = (campaignCode: string | undefined) => {
  const { projectCode, setProjectCode } = useFpCampaignProductsStore()
  const { destructuredData: exhibitorSettings } = useApiCampaignActivityInfo(campaignCode)
  const campaignProjectCodes = useMemo(() => exhibitorSettings?.brand_codes_info.map(brand => brand.project_code), [exhibitorSettings])

  const { destructuredData: productsData, isLoading: isProductsFetching } = useApiCampaignProductsList(
    projectCode
      ? {
        project_code: projectCode,
        campaign_code: campaignCode,
      }
      : undefined,
    {
      keepPreviousData: true,
      shouldRetryOnError: (error) => {
        if (error?.response?.status === 403) {
          return false
        }
        return true
      },
    },
  )

  const updateProjectCode = useCallbackEvent((newProjectCode: ProjectCode) => {
    setProjectCode(newProjectCode)
  })

  const setDefaultProjectCode = useCallback(() => {
    if (!campaignProjectCodes?.[0]) return
    /**
     * 如果一開始沒有 projectCode 或 projectCode 不在 campaignProjectCodes 中，則設置為 campaignProjectCodes 的第一個
     */
    if (!projectCode || !campaignProjectCodes.includes(projectCode)) {
      setProjectCode(campaignProjectCodes[0])
    }
  }, [campaignProjectCodes, projectCode, setProjectCode])

  return {
    productsData,
    isProductsFetching,
    projectCode,
    updateProjectCode,
    setDefaultProjectCode,
  }
}
